angular.module('qkr.tax').factory('taxService', ['$http', 'appConfig', 'utils', 'gettextCatalog',
	function($http, appConfig, utils, gettextCatalog) {
		return {
			getTaxRatesForMerchant(merchantId) {
    			return $http.get(appConfig.apiUrl + 'tax/' + merchantId + '/getTaxRatesForMerchant',
					{withCredentials: true}).then((response) => response.data);
    	},
    
    	getMerchantTaxRatesForInventoryItem(inventoryItemId) {
    		return $http.get(appConfig.apiUrl + 'tax/' + inventoryItemId + '/getMerchantTaxRatesForInventoryItem',
				{withCredentials: true}).then((response) => response.data);
    	},
    	
    	setMerchantTaxRatesForInventoryItem(inventoryItemId, taxRates) {
    		const setMerchantTaxRatesCommand = {};
    		setMerchantTaxRatesCommand.inventoryItemId = inventoryItemId;
    		setMerchantTaxRatesCommand.taxRates = taxRates;
    		
    		return $http.post(appConfig.apiUrl + 'tax/setMerchantTaxRatesForInventoryItem',
				setMerchantTaxRatesCommand).then((response) => response.data);
    	},
    	
    	getOutletTaxRateForInventoryItem(inventoryItemId) {
    		return $http.get(appConfig.apiUrl + 'tax/' + inventoryItemId + '/getOutletTaxRateForInventoryItem',
				{withCredentials: true}).then((response) => response.data);
    	}, 
    	
    	getTaxRatesForOutlet() {
    		return $http.get(appConfig.apiUrl + 'tax/getTaxRatesForOutlet', {withCredentials: true})
				.then((response) => response.data);
    	},
    	
    	setTaxRateForInventoryItemAndOutlet(inventoryItemId, salesTaxId, outletId) {
    		const setInventoryItemTaxRateCommand = {};
    		setInventoryItemTaxRateCommand.inventoryItemId = inventoryItemId;
    		setInventoryItemTaxRateCommand.salesTaxId = salesTaxId;
    		setInventoryItemTaxRateCommand.outletId = outletId;

		return $http.post(appConfig.apiUrl + 'tax/setTaxRateForInventoryItemAndOutlet',
			setInventoryItemTaxRateCommand)
				.then((response) => response.data);
    	},

			createTaxRateForMerchantAndRegion(merchantId, customRegionTax) {
				const taxRate = utils.multiplyXBy10PowerY(customRegionTax.rate, -2);

				const createMerchantRegionTaxRateCommand = {
					merchantId,
					taxRate,
					taxName: customRegionTax.name,
					discriminatedRegion: customRegionTax.region
				};

				return $http.post(appConfig.apiUrl + 'tax/createTaxRateForMerchantAndRegion',
						createMerchantRegionTaxRateCommand).then((response) => response.data);
			},

			getTaxRatesForMerchantAndRegion() {
				return $http.get(appConfig.apiUrl + 'tax/getTaxRatesForMerchantAndRegion',
					{withCredentials: true})
						.then((response) => response.data);
			},

			convertDiscriminatedTaxRateToCustomRegionTax(discriminatedTaxRate) {
				const taxRate = utils.multiplyXBy10PowerY(discriminatedTaxRate.salesTax.applicableTaxRate, 2);

				return {
					exists: !!discriminatedTaxRate.id,
					name: discriminatedTaxRate.salesTax.name,
					region: discriminatedTaxRate.discriminator,
					rate: taxRate,
					salesTaxId: discriminatedTaxRate.salesTax ? discriminatedTaxRate.salesTax.id : null
				};
			},

			updateTaxSettingsForMerchant(taxSettingsCommand) {
				return $http.post(appConfig.apiUrl + 'tax/updateTaxSettingsForMerchant', taxSettingsCommand)
					.then((response) => response.data);
			},

			getPriceTaxLabelForMerchant(merchant) {
				return (merchant.pricesSetPretax ?
						gettextCatalog.getString('Excluding') :
						gettextCatalog.getString('Including')) + ' ' + gettextCatalog.getString('Tax');
			}
		};
	}]);



// WEBPACK FOOTER //
// ./src/tax/services/tax.services.js